const greens = {
  apple: "#50B92E",
  atlantis: "#8ED12A"
}
const yellows = {
  schoolBusYellow: "#F6DA02"
}

const blues = {
  dodgerBlue: "#0F89FF"
}

const reds = {
  blazeOrange: "#FF5C03",
  burntOrange: "#C64702",
  butterCup: "#F69C0A",
  california: "#FFA30A",
  red: "#FF0F03",
  scarlet: "#F52502",
  trinidad: "#E45102"
}

const whites = {
  alabaster: "#FAFAFA",
  white: "#FFFFFF",
  wildSand: "#F5F5F5"
}

const grays = {
  black: "#000000",
  gray: "#7F7F7F",
  iron: "#DBDEE1",
  mineShaft: "#333333",
  nobel: "#B4B1B2",
  osloGray: "#969B9F",
  thunder: "#2E292E",
  tundora: "#4C4145"
}

const colors = {
  ...blues,
  ...greens,
  ...grays,
  ...reds,
  ...whites,
  ...yellows
}

export default colors
